













































import Vue, { PropOptions } from 'vue';

import { CampaignStatus, Campaign } from '../models';
import PageViewDetails from '@/components/campaign/PageViewDetails.vue';
import PageViewTabs from '@/components/campaign/PageViewTabs.vue';
import PageViewHeader from '@/components/campaign/PageViewHeader.vue';

export default Vue.extend({
  components: {
    PageViewDetails, PageViewTabs, PageViewHeader,
  },
  data() {
    const found = this.$store.state.campaign.campaigns.find(
      (c: Campaign) => c.objectId === this.$route.params.id,
    );
    return {
      campaign: found,
      loading: false,
    };
  },
  async mounted() {
    if (!this.campaign) {
      const campaign = await this.$store.dispatch('loadCapaignById', this.$route.params.id);
      this.campaign = campaign;
    } else {
      this.$store.commit('setCampaign', this.campaign);
    }
    this.$store.dispatch('loadTeams');
  },
  methods: {
    onUpdateCampaign() {
      this.loading = true;
      Promise.all([
        this.$store.dispatch('loadCapaignById', this.campaign.objectId),
        this.$store.dispatch('refreshCampaignMessagesByType'),
      ])
      .then((res) => {
        this.campaign = res[0];
        this.loading = false;
      })
      .catch((error) => {
        this.$store.commit('addSnackbar', {
          text: `Erro ao atualizar campanha`,
        });
      });
    },
  },
  watch: {
    '$store.state.campaign.capaigns'(val) {
      this.campaign = val.find(
        (c: Campaign) => c.objectId === this.$route.params.id,
      );
    },
  },
});
